import { createFileRoute } from "@tanstack/react-router"

import { dashboardFiltersSearchSchema } from "@/features/projects/projects-search-schema"
import { DashboardPage } from "@/pages/dashboard"

export const Route = createFileRoute("/_authenticated/dashboard")({
  validateSearch: (search) => dashboardFiltersSearchSchema.parse(search),
  component: DashboardPage,
})
